/**
 * Play motion directives — barrel + install plugin.
 *
 * Ported from the Play mockups (tobook_site_play_v2.html) into reusable Vue
 * directives. Every directive honours `prefers-reduced-motion` (see
 * ./motion-utils). Companion CSS lives in src/styles/motion.scss; cursor +
 * confetti flourishes live in src/composables/play.
 *
 * Register all of them globally in main.js:
 *   import PlayMotion from '@/directives/play'
 *   Vue.use(PlayMotion)
 *
 * …or cherry-pick a single one:
 *   import { magnetic } from '@/directives/play'
 *   Vue.directive('magnetic', magnetic)
 *
 * VUE3-MIGRATION: `app.directive(name, def)` replaces `Vue.directive`; the
 * install signature below already matches both (Vue 2 plugin `install(Vue)`,
 * Vue 3 plugin `install(app)`).
 */
import { magnetic } from './magnetic'
import { tilt } from './tilt'
import { reveal } from './reveal'
import { countup } from './countup'
import { marquee } from './marquee'

export {
  magnetic, tilt, reveal, countup, marquee,
}

export const directives = {
  magnetic, tilt, reveal, countup, marquee,
}

export default {
  install(app) {
    Object.keys(directives).forEach(name => {
      app.directive(name, directives[name])
    })
  },
}
